module.exports = __webpack_public_path__ + "img/Схема расчета Корзины и KVI.f714c5cc.png";